import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Home page
import HomePage from './pages/HomePage';

// Other pages
import AboutUs from './pages/AboutUs';
import MissionVision from './pages/MissionVision';
import PrincipalMessage from './pages/PrincipalMessage';
import Admissions from './pages/Admissions';
import Faculty from './pages/Faculty';
import Courses from './pages/Courses';
import News from './pages/News';
import ContactSection from './components/Contact';
import Downloads from './pages/Downloads';
import Gallery from './pages/Gallery';

import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-cyan-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/mission-vision" element={<MissionVision />} />
          <Route path="/principal-message" element={<PrincipalMessage />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/faculty" element={<Faculty />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/news" element={<News />} />
          <Route path='/contact-section'element={<ContactSection/>}/>
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;